import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { loadGoogleAnalytics, trackGooglePageView } from '@/lib/googleAnalytics';

/**
 * GoogleAnalytics — charge le suivi Google Analytics configuré par le
 * superadmin et mesure le trafic sur toute la plateforme Zifek.
 * À monter une seule fois au niveau racine de l'application.
 */
export default function GoogleAnalytics() {
  useEffect(() => {
    loadGoogleAnalytics().then((ok) => {
      if (ok) trackGooglePageView(window.location.pathname + window.location.search);
    });
  }, []);

  return null;
}

/** Suit les changements de route d'une application SPA (à monter dans le Router). */
export function RouteChangeTracker() {
  const location = useLocation();
  useEffect(() => {
    trackGooglePageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
}